export enum PlatformType {
  NopAccess = 'nop-access',
  OpoAccess = 'opo-access',
}

export enum PlatformFeature {
  CanAccessArchive = 'canAccessArchive',
  CanAccessOpoList = 'canAccessOpoList',
  CanAccessOrganApproval = 'canAccessOrganApproval',
  CanAccessServiceApproval = 'canAccessServiceApproval',
  CanAccessQuoteApproval = 'canAccessQuoteApproval',
  CanAccessInvoice = 'canAccessInvoice',
  CanAccessFullActivityLog = 'canAccessFullActivityLog',
  CanAccessDefaultOrganAcceptanceCriteria = 'canAccessDefaultOrganAcceptanceCriteria',
  CanEditAcceptanceCriteria = 'canEditAcceptanceCriteria',
  CanAccessMapTracking = 'canAccessMapTracking',
  CanAccessCaseNotes = 'canAccessCaseNotes',
  CanAccessTxCenterOrganization = 'canAccessTxCenterOrganization',
  CanAccessOpoOrganizationPage = 'canAccessOpoOrganizationPage',
  CanAccessOpoClinicalRequest = 'canAccessOpoClinicalRequest',
  CanAccessOpoLabel = 'canAccessOpoLabel',
  CanEditOpoContactsBeyondOrganOnOcs = 'canEditOpoContactsBeyondOrganOnOcs',
  CanAccessOpoReleaseNotes = 'canAccessOpoReleaseNotes',
  CanManageAttachments = 'canManageAttachments',
  CanManageDraftAttachments = 'canManageDraftAttachments',
  CanCreateDonorHospital = 'canCreateDonorHospital',
  CanAccessOffers = 'canAccessOffers',
  CanManageKidneyRandomization = 'canManageKidneyRandomization',
  CanAccessWaitingForInfoHint = 'canAccessWaitingForInfoHint',
}

export type PlatformFeatures = Record<PlatformFeature, boolean>;

export type PlatformLogo = {
  src: string;
  alt: string;
};

export type PlatformRoleConfig = {
  roleNames: Record<string, string>;
  roleDescriptions: Record<string, string>;
  roleWeight: Record<string, number>;
};

export type PlatformConfig = {
  type: PlatformType;
  label: string;
  logo: PlatformLogo;
  features: PlatformFeatures;
  roleConfig: PlatformRoleConfig;
};
